import app from 'flarum/forum/app';
import {extend} from 'flarum/common/extend';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Button from 'flarum/common/components/Button';
import Discussion from 'flarum/common/models/Discussion';
import AttachAlbumModal from './modals/AttachAlbumModal';

export default function () {
    extend(DiscussionControls, 'moderationControls', function (items, discussion: Discussion) {
        if (discussion.attribute('canAttachCimaiseAlbum')) {
            items.add('cimaise-attach', Button.component({
                icon: 'far fa-images',
                onclick() {
                    app.modal.show(AttachAlbumModal, {
                        discussion,
                    });
                },
            }, app.translator.trans('kilowhat-cimaise.forum.discussion-controls.attach-album')));
        }
    });
}
